import styled, { css } from "styled-components";

import { Snackbar } from "@material-ui/core";

import { SNACKBAR_TYPES } from "./Snackbar";

import { COLORS } from "constants/colorScheme";

export const CustomSnackbar = styled(Snackbar)`
  ${({ type }: { type: string }) => {
    switch (type) {
      case SNACKBAR_TYPES.ERROR:
        return css`
          && .MuiSnackbarContent-root {
            background-color: ${COLORS.RED};
          }
        `;
      case SNACKBAR_TYPES.SUCCESS:
        return css`
          && .MuiSnackbarContent-root {
            background-color: ${COLORS.CYAN_DARK};
          }
        `;
      case SNACKBAR_TYPES.INFO:
      default:
        return ``;
    }
  }}
`;
